<template>
  <div class="folio-item-wrapper">
    <div class="folio-item-content columns is-vcentered">
      <div class="column">
        <span class="item-description">Contado</span>
        <span class="is-pulled-right item-code">{{ item.cantidad }}</span>
      </div>
      <div class="column is-one-third">
        <b-field v-if="estaAbierto">
          <b-checkbox
            :disabled="item.cantidad === 0"
            :value="item.confirmado"
            @input="checkItemHandle"
          ></b-checkbox>
          <b-loading
            :active="item.loading"
            :is-full-page="false"
            :can-cancel="false"
          ></b-loading>
        </b-field>
        <b-field v-else>
          <b-icon :icon="item.confirmado ? 'check' : 'times'" />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ComparadorFolioItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('comparador', ['estaAbierto'])
  },
  methods: {
    checkItemHandle(newValue) {
      this.$store.dispatch('comparador/toggleFolioItem', {
        folioId: this.item.folioId,
        articuloId: this.item.articuloId,
        cantidad: this.item.cantidad,
        valor: newValue,
        todos: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$loading-icon-size: 2em;
span {
  display: block;

  &.item-code {
    font-weight: 700;
  }

  &.item-description {
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.folio-item-content {
  position: relative;
}

.folio-item-wrapper {
  border: 1px solid #a3a3a3;
  border-bottom: none;
  padding: 2px 10px;
  height: 48px;

  &:last-child {
    border-bottom: 1px solid #a3a3a3;
  }

  &:nth-child(odd) {
    background-color: lightblue;
  }
}
</style>
